import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import Article from 'components/Article';
import BreadcrumbsComponent, { breadcrumbsArticleDetailParser } from 'components/Breadcrumbs';
import { fetchArticle } from 'components/Article/ArticleActions';
import { getArticleApiUrl } from 'components/Article/ArticleHelpers';
import { getErrorComponent } from 'helpers/ContentHelper';
import Style from './ArticleDetail.module.scss';
import breadcrumbsTheme from './Breadcrumbs.module.scss';

const defaultState = {
  errors: null,
};

class ArticleDetail extends Component {
  constructor(props) {
    super(props);
    this.state = defaultState;
  }

  UNSAFE_componentWillUpdate(nextProps) {
    const {
      params: { articleId },
    } = this.props;
    const {
      params: { articleId: nextArticleId },
    } = nextProps;
    if (articleId !== nextArticleId) {
      this.setState(defaultState);
    }
  }

  setErrors = errors => {
    this.setState({ errors });
  };

  render() {
    const { params, accessToken, deviceId, pageViewEvent, setLoading, panels } = this.props;
    const { articleId } = params;
    const { errors } = this.state;
    if (errors) return getErrorComponent(errors);
    if (!articleId) return null;
    const articleUrl = getArticleApiUrl(articleId);
    const articleData = _.get(panels, 'member.0.items.member.0', null);
    return (
      <div className={Style.screen}>
        <div className={Style.article}>
          <Article
            url={articleUrl}
            accessToken={accessToken}
            deviceId={deviceId}
            pageViewEvent={pageViewEvent}
            setErrors={this.setErrors}
            setLoading={setLoading}
          />
        </div>
        <BreadcrumbsComponent
          data={breadcrumbsArticleDetailParser(articleData, params)}
          theme={breadcrumbsTheme}
        />
      </div>
    );
  }
}

ArticleDetail.fetchData = ({ store, params, accessToken }) => {
  const { articleId } = params;
  const articleUrl = getArticleApiUrl(articleId);
  return store.dispatch(fetchArticle(articleUrl, accessToken));
};

function mapStateToProps(state) {
  return {
    panels: state.article.panels,
  };
}

ArticleDetail.defaultProps = {
  accessToken: null,
  deviceId: null,
  panels: null,
  setLoading: null,
};

ArticleDetail.propTypes = {
  accessToken: PropTypes.string,
  deviceId: PropTypes.string,
  pageViewEvent: PropTypes.func.isRequired,
  panels: PropTypes.shape({}),
  params: PropTypes.shape({
    articleId: PropTypes.string,
  }).isRequired,
  setLoading: PropTypes.func,
};

export default connect(mapStateToProps, {})(ArticleDetail);
